import React, { Component } from 'react';
import { connect } from 'react-redux';

import SideMenuItem from './SideMenuItem';
import * as types from 'misc/types';
import { getText } from 'misc/helpers';

class SideMenu extends Component {
    render = () => {
        return (
            <nav className="side-menu">
                <img src="assets/images/digimail_logo_white.svg" className="logo" width="165" height="22" alt="Digimail" />
                <ul>
                    <SideMenuItem
                        label={getText('_3_2_IconMailbox', 'Brevlåda')}
                        icon="ico_brevlada"
                        iconWidth="40"
                        iconHeight="40"
                        url="inbox"
                        extraClasses={this.hasUnreadEnvelopes() ? 'unread' : ''}
                    />
                    <SideMenuItem
                        label={getText('_3_2_IconArchive', 'Arkiv')}
                        icon="ico_arkiv"
                        iconWidth="42"
                        iconHeight="42"
                        url="archives"
                        extraClasses=""
                    />
                    <SideMenuItem
                        label={getText('_3_2_IconMore', 'Inställningar')}
                        icon="ico_mer"
                        iconWidth="38"
                        iconHeight="38"
                        url="settings"
                        extraClasses="settings-item"
                    />
                </ul>
                <button className="button-white button-medium button-logout" onClick={e => this.logout()}>
                    {getText('CustomerOptionLogout', 'Logga ut')}
                </button>
            </nav>
        );
    };

    hasUnreadEnvelopes() {
        const { envelopes_inbox } = this.props;
       
        if (envelopes_inbox.data) {
            if (envelopes_inbox.data.find(envelope => envelope.state.read === false)) {
                return true;
            }
        }
        return false;
    }

    logout() {
        const { dispatch } = this.props;
        dispatch({ type: types.SAGA_LOGOUT.REQUEST, redirect: '/login' });
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions,
        envelopes_inbox: state.envelopes_inbox
    };
};

SideMenu = connect(mapStateToProps)(SideMenu);

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/shared/sidemenu/SideMenu.js